// Import polyfills
import 'core-js/stable';
import 'whatwg-fetch';

// Import styling
import '../sass/index.scss';
import 'bootstrap/dist/js/bootstrap';

// Import moment.js
import moment from 'moment';

// Import utils
import { documentReady } from './utils/document-ready';
import { getRootContextPath } from './utils/context-path';

// Import helpers
import { registerKeepQueryParams } from './helpers/keep-query-params';
import { registerCopyToClipboardListener } from './helpers/copy-to-clipboard';
import { registerConvertLocalDate } from './helpers/local-date-converter';
import { keepAlive } from './utils/keep-alive';

type PageLoader = () => Promise<{ init: () => void }>;

moment.locale(window.navigator.language);

documentReady(() => {
  // Helpers
  registerKeepQueryParams();
  registerCopyToClipboardListener();
  registerConvertLocalDate();

  // Pages
  registerPage('/select-tenant', () => import('./pages/select-tenant'));
  registerPage('/mfa/secure-login', () => import('./pages/mfa-secure-login-app'));
  registerPage('/ui/mfa', () => import('./pages/mfa-management'));
  registerPage('/ui/app-secrets', () => import('./pages/app-secret-management'));

  keepAlive();
});

const registerPage = (route: string, pageLoader: PageLoader) => {
  if (window.location.pathname === getRootContextPath() + route) {
    pageLoader().then(({ init }) => init());
  }
};
